import React,{useEffect,useState,useRef} from "react";
import { ChatBubbleLeftRightIcon,TrashIcon, InformationCircleIcon, FaceSmileIcon } from "@heroicons/react/24/outline";
import { PaperAirplaneIcon} from "@heroicons/react/24/solid";
import { collection,onSnapshot,doc,setDoc} from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import "../styles/home.css"
import { useAuthUser } from "../context/authuser";

function Chat() {
    const [showMsg,setShowMsg] = useState([])
    const [msg,setMsg] = useState('')
    const [emo,setEmo] = useState(false)
    const scrol = useRef();
    const {dbUser,liveUser} = useAuthUser()
    const [del,setDel] = useState({})

    useEffect(() => {
        // eslint-disable-next-line array-callback-return
        const name = dbUser.filter((item) => {
            if (liveUser?.uid === item?.uid) {
                return item
            }
        })
        setDel(...name)
    }, [dbUser, liveUser, liveUser?.uid])
    console.log(del)

    useEffect(() => {
          scrol.current?.scrollIntoView();
    },[showMsg])

    useEffect(() => {
        const colRef = collection(db, "message")
        onSnapshot(colRef, (res) => {
            const users = []
            res.docs.forEach((item) => {
                users.push(item.data().data)
            });  
            setShowMsg(users[0])
         })    
      },[])
      useEffect(() => {
        const colRef = doc(db, "message",'msg')
        if(showMsg?.length) {
            setDoc(colRef, {
                data: showMsg,
            },{merge:true})
        }
      },[showMsg])
    
    function sendMsg(e) {
        e.preventDefault();
        if(msg !==""){
        setShowMsg((prev) => [...prev, msg])
        }
        setMsg('')
}

   
function Delete(index){
    showMsg.splice(index, 1);
    setShowMsg([...showMsg]); 
}
 

return (
             <div  className="profile">
                            <form onSubmit={sendMsg}>
                                <div className="send-msg">
                                <FaceSmileIcon onClick={() => setEmo((prev) => !prev) } className="chats" />
                                {emo && <p className="emo">Use keyboard emoji</p>}
                                     <input type="text"
                                        placeholder="Send message"
                                        className="show-msg"
                                        maxlength="50"
                                        value={msg}
                                        onChange={(e) => setMsg(e.target.value)}
                                    />
                                 <PaperAirplaneIcon onClick={sendMsg} className="chats" />

                                </div>
                            </form>

                            <div className="alert">
                                <InformationCircleIcon className="info-circle"/>
                                <p className="auto">Messages deleted after one day</p>
                            </div>
                            <div className="message">
                                {showMsg?.map((item, index) => (
                                    <div key={index}  className="message-flex">
                                        <div className="flex">
                                            <ChatBubbleLeftRightIcon className="sizes" />
                                            <div>
                                                <div className="current-msg">{item}</div>
                                            </div>
                                        </div>
                                        <div className="remove-flex">
                                        {del?.email === "chat-lly1999@gmail.com" &&     
                                        <TrashIcon  onClick={() => Delete(index)}  className="remove"/>
                                         }
                                        </div>
                                    </div>
                                ))}
                                <div ref={scrol}/>
                            </div>

                        </div>
    )
}

export default Chat;